function parseTime(value) {
  if (!value) {
    return null;
  }
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }
  const text = String(value).trim();
  if (!text) {
    return null;
  }
  const direct = new Date(text);
  if (!Number.isNaN(direct.getTime())) {
    return direct;
  }
  const isoLike = new Date(text.includes("T") ? text : text.replace(" ", "T"));
  if (!Number.isNaN(isoLike.getTime())) {
    return isoLike;
  }
  const fallback = new Date(text.replace(/-/g, "/"));
  return Number.isNaN(fallback.getTime()) ? null : fallback;
}

export function resolveContestVoteRound(rounds = []) {
  if (!Array.isArray(rounds) || rounds.length === 0) {
    return null;
  }
  const list = rounds
    .filter((item) => item)
    .filter((item) => item.isShow === undefined || Number(item.isShow) === 1)
    .slice()
    .sort((prev, next) => {
      const prevPriority = [0, 3].includes(Number(prev.classify)) ? 0 : 1;
      const nextPriority = [0, 3].includes(Number(next.classify)) ? 0 : 1;
      if (prevPriority !== nextPriority) {
        return prevPriority - nextPriority;
      }
      const prevTime = parseTime(prev.startTime);
      const nextTime = parseTime(next.startTime);
      const prevStamp = prevTime ? prevTime.getTime() : Number.MAX_SAFE_INTEGER;
      const nextStamp = nextTime ? nextTime.getTime() : Number.MAX_SAFE_INTEGER;
      if (prevStamp !== nextStamp) {
        return prevStamp - nextStamp;
      }
      return Number(prev.id || 0) - Number(next.id || 0);
    });
  return list[0] || null;
}

export function resolveContestTimeline(item, nowMs = Date.now()) {
  const activityStart = parseTime(item && item.startTime);
  const activityEnd = parseTime(item && item.endTime);
  const publicEnd = parseTime(item && item.overTime);
  const voteRound = resolveContestVoteRound(item && item.rounds);
  const voteStart = parseTime(voteRound && voteRound.startTime);
  const voteEnd = parseTime(voteRound && voteRound.endTime);

  if (activityStart && nowMs < activityStart.getTime()) {
    return { key: "upcoming", text: "未开始" };
  }
  if (activityEnd && nowMs >= activityEnd.getTime()) {
    return { key: "hidden", text: "已结束" };
  }
  if (publicEnd && nowMs >= publicEnd.getTime()) {
    return { key: "completed", text: "已完成" };
  }
  if (voteStart && nowMs >= voteStart.getTime()) {
    if (!voteEnd || nowMs < voteEnd.getTime()) {
      return { key: "voting", text: "投票中" };
    }
    return { key: "ended", text: "已结束" };
  }
  if (voteEnd && nowMs >= voteEnd.getTime()) {
    return { key: "ended", text: "已结束" };
  }
  return { key: "signup", text: "报名中" };
}

export function resolveSignupBlockMessage(item) {
  const status = resolveContestTimeline(item);
  if (status.key === "voting") {
    return "当前活动已进入投票阶段，不能继续报名。";
  }
  if (status.key === "ended") {
    return "当前活动投票已结束，报名入口已关闭。";
  }
  if (status.key === "completed") {
    return "当前活动已完成，不能继续报名。";
  }
  if (status.key === "upcoming") {
    return "当前活动尚未开始，请稍后再试。";
  }
  return "当前活动已结束，不能继续报名。";
}
